import { SET_APP_CONFIGS, SetAppConfigsAction } from '../types'

const initialState = {}

const cashFlowStatementConfigReducer = (state = initialState, action: SetAppConfigsAction) => {
  switch (action.type) {
    case SET_APP_CONFIGS:
      return action.payload.cashFlowStatement
    default:
      return state
  }
}

export default cashFlowStatementConfigReducer
